import { supabase } from '@/lib/supabaseClient';

const GENERATED_BUCKET = 'generated';
const DEFAULT_EXPIRES_IN = 3600;

/**
 * Bucket generated приватный (см. supabase/migrations/20260904100700_storage.sql) —
 * картинку нельзя получить по прямому публичному URL, только через
 * подписанную ссылку или .download().
 */
export async function getSignedImageUrl(
  path: string,
  expiresIn = DEFAULT_EXPIRES_IN,
): Promise<string | null> {
  if (!supabase) {
    return null;
  }

  const { data, error } = await supabase.storage
    .from(GENERATED_BUCKET)
    .createSignedUrl(path, expiresIn);

  return error ? null : data.signedUrl;
}

/**
 * Батч вместо запроса на каждую карточку списка. Сбой одного пути не должен
 * ронять весь список — на его месте просто null, а не ошибка целиком.
 */
export async function getSignedImageUrls(
  paths: string[],
  expiresIn = DEFAULT_EXPIRES_IN,
): Promise<Map<string, string | null>> {
  const result = new Map<string, string | null>();

  if (!supabase || paths.length === 0) {
    return result;
  }

  const { data, error } = await supabase.storage
    .from(GENERATED_BUCKET)
    .createSignedUrls(paths, expiresIn);

  if (error || !data) {
    return result;
  }

  for (const entry of data) {
    result.set(entry.path ?? '', entry.error ? null : entry.signedUrl);
  }

  return result;
}

export async function downloadImageBlob(path: string): Promise<Blob | null> {
  if (!supabase) {
    return null;
  }

  const { data, error } = await supabase.storage.from(GENERATED_BUCKET).download(path);

  return error ? null : data;
}
